<template>
  <v-layout
    fill-height
    column
    justify-start
    align-content-start
    style="width: 100%"
    class="scroll-fire-fox"
  >
    <div style="margin: 0px 15px 0px" v-if="!selectedTool">

      <v-text-field
        v-model="search"
        :label="$t('FindTool')"
        class="layers-search"
      />
    </div>

    <div class="tools-container" v-if="!selectedTool">
      <v-treeview
        open-all
        :items="tools"
        :search="search"
        item-key="id"
        item-text="label"
        return-object
        id="tool-tree"
      >
        <template v-slot:prepend="{ item, open }">
          <v-icon
            v-if="!item.icon"
            medium
            color="##0000008a"
            class="mb-1"
          >
            {{ open ? "mdi-menu-down" : "mdi-menu-right" }}
          </v-icon>
        </template>
        <template v-slot:label="{ item, open }">
          <div
            :class="{
              selected: item === selectedTool,
              header: item.children,
              tool: !item.children
            }"
            @click="selectTool(item)"
          >
         
            <v-icon
              v-if="item.icon"
              small
              :class="{ disabled: item.locked }"
              color="#32383D"
              class="mr-2 ml-3"
              style="font-size: 15px"
            >
              {{ item.icon }}

            </v-icon>
            <div class="label" :class="{ disabled: item.locked }">
              {{ item.label }}
            </div>
          </div>  
        </template> 
      </v-treeview>
    </div>
    <single-point-of-failure />
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import SidebarButton from "../../Home/SideBar/SidebarButton.vue";
import MeasurementsToolbar from "@/components/Home/Toolbars/MeasurementsToolbar";
import SinglePointOfFailure from "./spf/SinglePointOfFailure.vue";
import { bus } from "@/main";

export default {
  name: "RightSidebarTools",

  components: {
    SidebarButton,
    MeasurementsToolbar,
    SinglePointOfFailure
  },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      /**
       * Save the search value
       */
      search: "",
      measurementsDraw: null,

      /**
       * List of tools
       */
      tools: [
        {
          id: "preventionAndMaintenance",
          label: this.$i18n.t("PreventionAndMaintenance"),
          children: [
            {
              id: "failureAnalysis",
              label: this.$i18n.t("FailureAnalysis"),
              icon: "mdi-scissors-cutting",
              locked: !this.userHasPermission(
                "failure_analysis",
                "network",
                "tool"
              )
            },
            {
              id: "singlePointofFailure",
              label: this.$i18n.t("SinglePointofFailure"),
              icon: "mdi-scissors-cutting",
              locked: !this.userHasPermission(
                "failure_analysis",
                "network",
                "tool"
              )
            }
          ],
        },
         {
          id: "Measurement",
          label: this.$i18n.t("Measurement"),
          children: [
            {
              id: "length",
              label: this.$i18n.t("Lenght"),
              icon: "straighten",
              locked: false
            },
             {
              id: "area",
              label: this.$i18n.tc("Area"),
              icon: "mdi-crop-square",
              locked: false
            },
             {
              id: "angle",
              label: this.$i18n.t("Azimuth"),
              icon: "mdi-angle-acute",
              locked: false
            },
          ],
        }
      ],
    };
  },

  computed: {
    /**
     * Returns the selected tool
     */
    selectedTool() {
      return this.$store.getters.getSelectedTool;
    },
    /**
     * defines whether the measure tool is selected or not
     * @returns {any}
     */
    showMeasurementsToolbar() {
      return this.$store.getters.isMeasurementsToolbarOpen;
    },
  },

  watch: {
    showMeasurementsToolbar(show) {
      if (!show) {
        this.clearMeasurements();
      }
    },

     selectedCreateTool(selectedTool) {
      if (selectedTool !== "") {
        this.setSelectedMeasureTool("");
      }
    },

    selectedToolsAction(newValue) {
      if (newValue === "select") {
        this.setSelectedMeasureTool("");
      }
    }
  },

  destroyed() {
    this.setSelectedMeasureTool("");
    this.$emit("resetMeasurements");
  },
 
  methods: {
    ...mapActions([
      "setSelectedTool",
      "setMeasurementsToolbarState",
      "setSelectedMeasureTool",
    ]),
    /**
     * Set the tool chosen by the user as the selected tool
     */
    selectTool(item) {
      if (this.userHasPermission("failure_analysis", "network", "tool")) {
        if (!item.children) {
          if (this.selectedTool === item) {
            this.setSelectedTool(null);
          } else {
            this.setSelectedTool(item);
            this.setSelectedMeasureTool(item);
            this.selectedMeasurementOptions(item)
          }
        }
      }
    },
    
    selectedMeasurementOptions(item) {
        switch (this.selectedTool.id) {
          case "length":
          bus.$emit("change-measurement", "calculateLength");
          break;
          case "area":
          bus.$emit("change-measurement", "calculateArea");
          break;
          case "angle":
          bus.$emit("change-measurement", "calculateAngle");
          break;
        }
      }
    },
  }
</script>

<style scoped>
.tools-container {
  width: 100%;
  height: 90%;
  overflow: auto;
  padding-bottom: 4px;
}

.tools-container{
  padding: 0px 6px;
  margin-top: 25px !important;
}

.tool {
  display: flex;
  min-height: 26px;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}

.tool:hover {
  background-color: rgba(236, 236, 236, 0.747);
}

.label {
  color: #1e2329;
  font-size: 9px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header .label {
  text-transform: uppercase;
  font-size: 8px;
  font-weight: bold;
  color: #707070;
}

.layers-search {
  font-size: 12px;
  flex: unset;
  height: 30px;
  border-radius: unset;
}

.selected .label,
.selected i {
  color: var(--v-accent-base) !important;
}
</style>

<style>
.layers-search .v-text-field__details {
  display: none;
}

#tool-tree > div > div.v-treeview-node__root > button {
  display: none;
}

#tool-tree > div > div.v-treeview-node__children .v-treeview-node__level {
  display: none;
}

#tool-tree > div > div.v-treeview-node__root {
  min-height: 24px;
  padding: 0;
  margin: 3px 0;
}

#tool-tree
  > div
  > div.v-treeview-node__children
  > div
  > div.v-treeview-node__root {
  min-height: 26px;
  padding: 0;
}

#tool-tree .v-treeview-node__content {
  margin: 0;
}
.disabled {
  opacity: 0.4;
}

.layer-search {
  flex: 0 0 auto;
  width: 100%;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/RightSidebar/RightSidebarTools.vue